import { defineStore } from "pinia";
import { fetchWrapper } from "@/utils/helpers/fetch-wrapper";

const baseUrl = `${import.meta.env.VITE_API_URL}/auth`;

export interface User {
  id: string;
  firstName: string;
  lastName: string;
  email: string;
  roles: string[];
  status: string;
  avatar: string;
  authorizerLevel: number;
}

export interface AuthResponse {
  accessToken: string;
  refreshToken: string;
  user: User;
}

export const useAuthStore = defineStore("auth", {
  state: () => ({
    // initialize state from local storage to enable user to stay logged in
    // @ts-ignore
    user: JSON.parse(localStorage.getItem("user") || "null"),
    returnUrl: null,
    accessToken: localStorage.getItem("accessToken") || "",
    refreshToken: localStorage.getItem("refreshToken") || "",
  }),
  getters: {
    isLoggedIn: (state) => !!state.user,
    getSignatureLevel: (state) => state.user?.authorizerLevel,
  },
  actions: {
    async login(username: string, password: string) {
      const response = await fetchWrapper.post(`${baseUrl}/login`, {
        username,
        password,
      });

      // update pinia state
      this.user = response.user;
      this.accessToken = response.accessToken;
      this.refreshToken = response.refreshToken;

      // store user details and jwt in local storage to keep user logged in between page refreshes
      localStorage.setItem("user", JSON.stringify(this.user));
      localStorage.setItem("accessToken", this.accessToken);
      localStorage.setItem("refreshToken", this.refreshToken);

      // Forzar recarga completa de la app para que todos los módulos
      // (sidebar, permisos, etc.) se re-evalúen con el nuevo usuario
      const redirectTo = this.returnUrl || "/";
      window.location.href = redirectTo;
    },
    updateTokens(accessToken: string, refreshToken: string) {
      this.accessToken = accessToken;
      this.refreshToken = refreshToken;
      localStorage.setItem("accessToken", accessToken);
      localStorage.setItem("refreshToken", refreshToken);
    },
    logout() {
      this.user = null;
      this.accessToken = "";
      this.refreshToken = "";
      localStorage.removeItem("user");
      localStorage.removeItem("accessToken");
      localStorage.removeItem("refreshToken");

      // Forzar recarga completa para limpiar todos los módulos y stores cacheados
      const loginPath = "/auth/login";
      if (window.location.pathname !== loginPath) {
        window.location.href = loginPath;
      }
    },
  },
});
